module.exports = __webpack_public_path__ + "static/media/training_library.b64f971c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/training_library.svg
// module id = 2722
// module chunks = 0